/* eslint-disable compat/compat */

const apiUrl = `https://foursixty.com/api/v2/${window.theme.fourSixty.apiKey}/timeline?post_categories=Shopify%20Looks&use_stored_image_url=true`

let pageTotal
const promises = []

// returns a promise
async function getFourSixtyPage (url) {
  const response = await fetch(url)
  return response.json()
}

async function returnFirstPage (url) {
  const data = await getFourSixtyPage(url)

  pageTotal = Math.round(data.count / data.results.length)
}

async function getRestOfPages () {
  let i = 1
  do {
    const url = `https://foursixty.com/api/v2/${window.theme.fourSixty.apiKey}/timeline?page=${i}&post_categories=Shopify%20Looks&use_stored_image_url=true`
    promises.push(getFourSixtyPage(url))
    i++
  } while (i <= pageTotal)
}

async function init () {
  if (sessionStorage.lookbooks) return

  await returnFirstPage(apiUrl)
  await getRestOfPages()
  Promise.all(promises).then(values => {
    const lookBookData = values
      .flatMap(value => value.results)
      .filter(t => t.links.length > 0)

    window.theme.fourSixty.data = lookBookData

    sessionStorage.setItem(
      'lookbooks',
      JSON.stringify(window.theme.fourSixty.data),
    )

    const lookbookDataEvent = new CustomEvent('lookbookDataIsReady')

    document.dispatchEvent(lookbookDataEvent)
  })
}

init()
